
import 'jquery-clickout';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'info_map_legend';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$el.find( '.btn' ).on( 'click', () => this.open( true ) );
			this.$el.find( '.close' ).on( 'click', () => this.open( false ) );
		}
		else{
			this.$el.find( '.btn' ).off( 'click', () => this.open( true ) );
			this.$el.find( '.close' ).off( 'click', () => this.open( false ) );
		}
		this.activateclickOut(b);
	}

	open(b){
        if ( b ){
        	this.$el.addClass( 'open' );
        }
        else{
        	this.$el.removeClass( 'open' );
        }
        this.$el.trigger( b ? 'info-map-legend:open' : 'info-map-legend:close' );
 	}

 	activateclickOut(b){
 		if ( b ){
 			this.$el.on( 'clickout', ()=>this.open(false) );
 		}
 		else{
 			this.$el.off( 'clickout', ()=>this.open(false) );
 		}
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}


